const app_id = '387'
const file_column_headers = [
  "COURSE_PROVIDER_AI_CODE",
  "COURSE_CODE",
  "CLASS_SECTION_NAME",
  "STUDENT_AI_CODE",
  "STUDENT_FIRST_NAME",
  "STUDENT_MIDDLE_INITIAL",
  "STUDENT_LAST_NAME",
  "STUDENT_GENDER",
  "STUDENT_DATE_OF_BIRTH",
  "STUDENT_CURRENT_GRADE",
  "STREET_ADDRESS_1",
  "STREET_ADDRESS_2",
  "STREET_ADDRESS_3",
  "MAILING_ADDRESS_REGION",
  "CITY",
  "STATE_CODE",
  "ZIP",
  "COUNTRY_CODE",
  "STUDENT_EMAIL_ADDRESS",
  "STUDENT_ID",
  "AP_FEE_STATUS",
  "STUDENT_PREFERRED_LANGUAGE",
  "LANG_STUDY",
  "LANG_HOME",
  "PARENT_OR_GUARDIAN_1_EDUCATION_LEVEL",
  "PARENT_OR_GUARDIAN_2_EDUCATION_LEVEL",
  "EXAM_DATE_TYPE",
  "LATE_TESTING_REASON_CODE",
  "TEST_CENTER_IDENTIFIER",
  "DUPLICATE",
]

const file_column_custom_width = {
  COURSE_PROVIDER_AI_CODE: 182,
  COURSE_CODE: 135,
  CLASS_SECTION_NAME: 164,
  STUDENT_AI_CODE: 130,
  STUDENT_FIRST_NAME: 155,
  STUDENT_MIDDLE_INITIAL: 170,
  STUDENT_LAST_NAME: 150,
  STUDENT_GENDER: 126,
  STUDENT_DATE_OF_BIRTH: 166,
  STUDENT_CURRENT_GRADE: 170,
  STREET_ADDRESS_1: 150,
  STREET_ADDRESS_2: 150,
  STREET_ADDRESS_3: 150,
  MAILING_ADDRESS_REGION: 180,
  CITY: 150,
  STATE_CODE: 110,
  ZIP: 100,
  TEXT_MSG_OPT_IN: 130,
  STUDENT_EMAIL_ADDRESS: 175,
  STUDENT_ID: 120,
  AP_FEE_STATUS: 135,
  STUDENT_PREFERRED_LANGUAGE: 213,
  LANG_STUDY: 110,
  LANG_HOME: 110,
  PARENT_OR_GUARDIAN_1_EDUCATION_LEVEL: 265,
  PARENT_OR_GUARDIAN_2_EDUCATION_LEVEL: 265,
  EXAM_DATE_TYPE: 120,
  LATE_TESTING_REASON_CODE: 183,
  TEST_CENTER_IDENTIFIER: 150,
  DUPLICATE: 85,
  RECORD_NUM: 122,
}

const duplicate_editable_cols = [
  "STUDENT_FIRST_NAME",
  "STUDENT_MIDDLE_INITIAL",
  "STUDENT_LAST_NAME",
  "STUDENT_DATE_OF_BIRTH",
  "STUDENT_GENDER",
  "STUDENT_AI_CODE",
  "STUDENT_ID",
  "COURSE_CODE",
]

let extended_default_cols = {
  STREET_ADDRESS_1: [
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "STATE_CODE",
    "ZIP",
    "COUNTRY_CODE",
  ],
  STREET_ADDRESS_2: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "STATE_CODE",
    "ZIP",
    "COUNTRY_CODE",
  ],
  STREET_ADDRESS_3: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "STATE_CODE",
    "ZIP",
    "COUNTRY_CODE",
  ],
  MAILING_ADDRESS_REGION: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "CITY",
    "STATE_CODE",
    "ZIP",
    "COUNTRY_CODE",
  ],
  CITY: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "STATE_CODE",
    "ZIP",
    "COUNTRY_CODE",
  ],
  STATE_CODE: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "ZIP",
    "COUNTRY_CODE",
  ],
  ZIP: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "STATE_CODE",
    "COUNTRY_CODE",
  ],
  COUNTRY_CODE: [
    "STREET_ADDRESS_1",
    "STREET_ADDRESS_2",
    "STREET_ADDRESS_3",
    "MAILING_ADDRESS_REGION",
    "CITY",
    "STATE_CODE",
    "ZIP",
  ],
  LANG_STUDY: ["COURSE_CODE"],
  LANG_HOME: ["COURSE_CODE"],
  EXAM_DATE_TYPE: ["COURSE_CODE", "LATE_TESTING_REASON_CODE"],
  LATE_TESTING_REASON_CODE: ["COURSE_CODE", "EXAM_DATE_TYPE"],
  TEST_CENTER_IDENTIFIER: ["TEST_CENTER_IDENTIFIER"],
}

export default {
  // Add common constants values here
  app_id,
  file_column_headers,
  file_column_custom_width,
  duplicate_editable_cols,
  extended_default_cols,
}